// choices/endChoices.js
const endChoicesSrb = [
  {
    label: "Откријте ваше боје",

    value: "results",
  },
  {
    label: "Хајде да их још више специјализујемо",
    value: "large",
  },
];

export default endChoicesSrb;
